const alphaNumSpaces = /^[0-9A-ZÁÉÍÑÓÚÜÄÖÜßČĎĚŇŘŠŤŮÝŽ\-.,\s]*$/i

export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return alphaNumSpaces.test(value)
  }
}
